
<ng-container *ngIf="player&&(seat==1||seat==3)">
    <div style="display: flex;">
        <div class="player-name bottom" *ngIf="seat==3">
            <div>Player:</div>
            <div>{{player.name}}</div>
            <div>{{player.msg}}</div>
            <button (click)="giveup(player)">投了</button>
        </div>
        <div style="width: 300px;height: 100%;display:inline-flex;position: relative;padding-top: 5px;"
            [ngStyle]="{marginLeft:seat==3?'0px':'80px',width:seat==3?'300px':'250px'}">
            <div class="card-stack" [attr.name]="c.text" *ngFor="let c of player.hands;let i=index" [ngStyle]="{left:(i*12)+'px'}" #cardEl>
                <app-poker-card [card]="c" (cardClick)="onCardClick($event)" (cardRightClick)="onCardRightClick($event)" ></app-poker-card>
            </div>
        </div>
        
        <div class="player-name top" *ngIf="seat==1">
            <div>Player:</div>
            <div>{{player.name}}</div>
            <div>{{player.msg}}</div>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="seat==2||seat==4">
    <div class="player-name left" *ngIf="seat==4">
        <div>Player:</div>
        <div>{{player.name}}</div>
        <div>{{player.msg}}</div>
    </div>
    <div style="width: 100%;height: 300px;display: flex;position: relative; padding-left: 20px;" *ngIf="player"
        [ngStyle]="{marginTop:seat==4?'0px':'80px',height:seat==4?'300px':'250px'}">
        <div class="card-stack" [attr.name]="c.text" *ngFor="let c of player.hands;let i=index" [ngStyle]="{top:(i*12)+'px'}"
            style="transform: rotate(90deg);" #cardEl>
            <app-poker-card [card]="c" (cardClick)="onCardClick($event)"  (cardRightClick)="onCardRightClick($event)"></app-poker-card>
        </div>
    </div>
    <div class="player-name right" *ngIf="seat==2">
        <div>Player:</div>
        <div>{{player.name}}</div>
        <div>{{player.msg}}</div>
    </div>
</ng-container>

    
